export default Object.freeze({
  BASIC: 0,
  SPECIAL: 10
})
